import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setGroupBillingDivision = data =>
  call(websocketFetch, 'set_group_billing_division', data);
